import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { t } from '../../services/i18nService';
import TOCFilters from '../tableOfContents/TOCFilters';
import SubmitAssessmentContainer from '../delivering/SubmitAssessment';

import styles from './header.scss';
import deliveringSubHeaderSelector from '../../selectors/header/DeliveringSubHeaderSelector';

const DeliveringSubHeaderPure = (props) => {
    const {
        defaultHeaderCaption,
        defaultHeaderSubCaption,
        defaultUnattemptedSubCaption,
        noAttemptedQuestions,
        noUnAttemptedMandatoryQuestions,
        showSimplifiedVersionForPublicTests,
        simplifiedHeaderCaption,
        a11yV5SupportedAndAbove,
    } = props;

    const headerRef = useRef(null);

    useEffect(() => {
        const allTab = document.getElementById('tab-all');
        if (allTab) {
            allTab.focus();
        } else if (headerRef.current) {
            headerRef.current.focus();
        }
    }, []);

    const getSimplifiedHeader = () => {
        return (<p>
            { simplifiedHeaderCaption }
        </p>);
    };

    const getDefaultHeader = () => {
        const showUnattemptedCaption = defaultUnattemptedSubCaption?.length > 0;
        return (<div className={showUnattemptedCaption ? styles.hasUnattemptedCaption : ''}>
            <h1
                tabIndex="-1"
                ref={headerRef}
                dangerouslySetInnerHTML={{ __html: defaultHeaderCaption }}
            />
            <div dangerouslySetInnerHTML={{ __html: defaultHeaderSubCaption }} />

            { showUnattemptedCaption &&
                <div className={styles.unattemptedCaption} dangerouslySetInnerHTML={{ __html: defaultUnattemptedSubCaption }} />
            }
        </div>);
    };

    const submitAssessmentContainerClasses = [styles.rightSide];
    if (showSimplifiedVersionForPublicTests) {
        submitAssessmentContainerClasses.push(styles.forceOnRightSide);
    }

    return (
        <div className={styles.tocHeaderWrapper}>
            <div className={styles.statusSection}>
                <div className={styles.subHeaderTitle}>
                    { showSimplifiedVersionForPublicTests
                        ? getSimplifiedHeader()
                        : getDefaultHeader()
                    }
                </div>
                <div className={submitAssessmentContainerClasses.join(' ')}>
                    <SubmitAssessmentContainer
                        noAttemptedQuestions={noAttemptedQuestions}
                        noUnAttemptedMandatoryQuestions={noUnAttemptedMandatoryQuestions}
                    />
                </div>
            </div>
            <h2 className="sr-only">{t('testOverview.tocHeader_sr_only')}</h2>

            {!a11yV5SupportedAndAbove && !showSimplifiedVersionForPublicTests && <TOCFilters {...props} />}
        </div>
    );
};

DeliveringSubHeaderPure.propTypes = {
    defaultHeaderCaption: PropTypes.string.isRequired,
    defaultHeaderSubCaption: PropTypes.string.isRequired,
    defaultUnattemptedSubCaption: PropTypes.string,
    noAttemptedQuestions: PropTypes.bool.isRequired,
    noUnAttemptedMandatoryQuestions: PropTypes.number,
    showSimplifiedVersionForPublicTests: PropTypes.bool.isRequired,
    simplifiedHeaderCaption: PropTypes.string.isRequired,
    a11yV5SupportedAndAbove: PropTypes.bool.isRequired,
};

const DeliveringSubHeader = props => (
    <DeliveringSubHeaderPure {...props} {...deliveringSubHeaderSelector.selectProps(props)} />
);

export default DeliveringSubHeader;
